import { gql } from '@apollo/client';
import COMPONENT_COLORS from './COMPONENT_COLORS';
import COMPONENT_SIZES from './COMPONENT_SIZES';
const COMPONENT_COLORS_AND_SIZES = gql `
  ${COMPONENT_COLORS}
  ${COMPONENT_SIZES}
  fragment ComponentColorsAndSizesFragment on ComponentNode {
    ...ComponentColorsFragment
    ...ComponentSizesFragment
  }
`;
export default COMPONENT_COLORS_AND_SIZES;
